import React, { useEffect, useState } from 'react'
import './home.css'
import { API_URL } from '../../Config';
import Cookies from 'js-cookie';

function Home() {
    const [cName, setcName] = useState('');
    const [amount, setAmount] = useState('');
    const [type, setType] = useState('');
    const [account, setAccount] = useState('');
    const [success, setSuccess] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
  
    const [cashData, setCashData] = useState({ amount: 0, limit1: 0, limit2: 0 });    

    useEffect(() => {
        fetch(`${API_URL}/cashdata`)
          .then(res => res.json())
          .then(data => {
            setCashData(data[0]);
          })
          .catch(err => console.log(err));
      }, []);

      
    const handlecNameChange = (event) => {
        setcName(event.target.value);
      };
    
      const handleAmountChange = (event) => {
        setAmount(event.target.value);
      };
    
      const handleTypeChange = (event) => {
        setType(event.target.value);
      };
    
      const handleAccountChange = (event) => {
        setAccount(event.target.value);
      };
    
      const handleSubmit = async (event) => {
        event.preventDefault();
        if (cName === '' || amount === '' || type === '' || account === '') {
          setAlertMessage('Please fill necessary Details!!');
          return;
        }
        const through = Cookies.get('name');
        const data = { cName, amount, type, account, through };
        try {
          const response = await fetch(`${API_URL}/post`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
          });
          if (!response.ok) {
            const errorResponse = await response.json(); 
            throw new Error(errorResponse.message);
          }      
          setSuccess(true);
          setcName('');
          setAmount('');
          setType('');
          setAccount('');
          setAlertMessage(null);
        } catch (error) {
          console.error('There was an error:', error);
          setAlertMessage(error.message);
        }
        fetch(`${API_URL}/cashdata`)
        .then(res => res.json())
        .then(data => setCashData(data[0]))
        .catch(err => console.log(err));    
      };
    
  return (
    <div className='new-data'>
      <div className="home-cash-limit">
          <div className="home-cash">
            <p>Total cash:</p>
            <p>{cashData.amount}</p>
          </div>
          <div className="home-cash">
            <p>Account1 limit:</p>
            <p>{cashData.limit1}</p>
          </div>
          <div className="home-cash">
            <p>Account2 limit:</p>
            <p>{cashData.limit2}</p>
          </div>
        </div>
      <div className="new-data-container">
        <h2>Add new transaction</h2>
        <form className="transaction-form" onSubmit={handleSubmit}>
              <input type="text" placeholder='Customer Name' name='cName' value={cName} onChange={handlecNameChange}/>
              <input type="number" placeholder='Transaction Amount' name='amount' value={amount} onChange={handleAmountChange}/>
              <select name="type" value={type} onChange={handleTypeChange}>
                <option value="" disabled defaultValue>--Debit/Deposit--</option>
                <option value="1">Debit</option>
                <option value="2">Deposit</option>
              </select>
              <select name="account" value={account} onChange={handleAccountChange}>
                <option value="" disabled defaultValue>--Select Account--</option>
                <option value="1">Account 1</option>
                <option value="2">Account 2</option>
              </select>
              <button>Add</button>
        </form>
              {alertMessage && <p style={{color:'#ee2323', fontWeight:'bold'}}>{alertMessage}</p>}
              {success && <div style={{color:'#143692f1', fontWeight:'bold'}}>Success! Transaction successful.</div>}
      </div>
    </div>
  )
}

export default Home
